module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-MediumItalic.bcd456b.eot";